import { render } from "./update_both.vue?vue&type=template&id=04096997"
import script from "./update_both.vue?vue&type=script&lang=js"
export * from "./update_both.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260406232202/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__